import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowActionsService {

  constructor() {
  }

  public static clearWindowSelections(): void {
    if (window.getSelection) {
      if (window.getSelection().empty) { // Chrome
        window.getSelection().empty();
      } else if (window.getSelection().removeAllRanges) { // Firefox
        window.getSelection().removeAllRanges();
      }
    }
  }
}
